// extracted by mini-css-extract-plugin
export default {"messages":"Notifications_messages__6t7ta"};